import * as types from './types';
import {
  AdminToolBookStatementTeacherCourseList,//教师课程列表
  AdminToolBookStatementTeacherSelectCatalog,//教师分配用书
  AdminToolBookStatementTeacherCourseDelete,//教师课程删除
} from 'src/model/AdminModel';

export default{
  actionAdminToolBookStatementTeacherCourseList({commit, state}, query){
    if (state.adminToolBookStatementTeacherCourseList === 'loading'){
      return Promise.reject();
    }
    commit(types.ACTION_ADMIN_TOOL_BOOK_STATEMENT_TEACHER_COURSE_LIST, {
      state: 'loading'
    });
    return AdminToolBookStatementTeacherCourseList.getInstance().execute(query).then((response) => {
      commit(types.ACTION_ADMIN_TOOL_BOOK_STATEMENT_TEACHER_COURSE_LIST, {
        ...response,
        state: 'loadend',
        'list': response.list
      });
      return response;
    }).catch((err) => {
      commit(types.ACTION_ADMIN_TOOL_BOOK_STATEMENT_TEACHER_COURSE_LIST, {
        state: 'loaderr'
      });
      return Promise.reject(err);
    });
  },

  actionAdminToolBookStatementTeacherSelectCatalog({commit, state}, query){
    return AdminToolBookStatementTeacherSelectCatalog.getInstance().execute(query);
  },

  actionAdminToolBookStatementTeacherCourseDelete({commit, state}, query){
    return AdminToolBookStatementTeacherCourseDelete.getInstance().execute(query);
  },
}






// WEBPACK FOOTER //
// ./src/store/Admin/modules/teacherTextBookSchedule/actions.js